import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { jwtDecode } from 'jwt-decode';

import { JwtCustomPayload } from '../auth/jwt-payload';
import { authConstants } from '../../common/constants/auth.constants';
// import * as uuid from 'uuid';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    jwtHelper = new JwtHelperService();

    constructor() {}

    public getToken(): string {
        return localStorage.getItem('token') ?? '';
    }

    public getSecretKey(): string {
        return localStorage.getItem('secretkey') ?? '';
    }

    public decodeJwtPayload(): JwtCustomPayload {
        const token: string = this.getToken();

        return jwtDecode<JwtCustomPayload>(token);
    }

    public getUserId(): string {
        const tokenPayload = this.decodeJwtPayload();

        return tokenPayload?.id;
    }

    public getUserName(): string {
        const tokenPayload = this.decodeJwtPayload();

        return `${tokenPayload.firstName} ${tokenPayload.lastName}`;
    }

    public getFirstName(): string {
        const tokenPayload = this.decodeJwtPayload();

        return `${tokenPayload.firstName}`;
    }

    public getLastName(): string {
        const tokenPayload = this.decodeJwtPayload();

        return `${tokenPayload.lastName}`;
    }

    public getEmail(): string {
        const tokenPayload = this.decodeJwtPayload();
        return `${tokenPayload.sub}`;
    }

    public getscofAuthenticationMethodToken(): object {
        const tokenPayload = this.decodeJwtPayload();
        // return `${tokenPayload.appCtaSettings}`; 
        return  tokenPayload.appCtaSettings;
    }

    public getProjectsEnabled(): string {
        const tokenPayload = this.decodeJwtPayload();

        return `${tokenPayload.projects}`;
    }

    public isProjectEnabled(project: string): boolean {
        return this.getProjectsEnabled().includes(project);
    }

    public isAuthenticated(): boolean {
        const token = this.getToken();

        return !this.jwtHelper.isTokenExpired(token);
    }

    public hasRole(expectedRole: string): boolean {
        if (this.isAuthenticated()) {
            const tokenPayload = this.decodeJwtPayload();

            return tokenPayload?.roles.filter((role) => role.name === expectedRole).length > 0;
        }

        return false;
    }

    public isPaymentEnabled(): boolean {
        if (this.isAuthenticated()) {
            const tokenPayload = this.decodeJwtPayload();

            return tokenPayload?.roles.filter((role) => role.name === authConstants.ROLE_PAYMENTS).length > 0;
        }

        return false;
    }

    public isLoggedIn(): boolean {
        if (this.isAuthenticated()) {
            const tokenPayload = this.decodeJwtPayload();

            return tokenPayload?.roles.filter((role) => role.name === authConstants.ROLE_USER).length > 0;
        }

        return false;
    }

    public isSuperAdmin(): boolean {
        if (this.isAuthenticated()) {
            const tokenPayload = this.decodeJwtPayload();

            return tokenPayload?.roles.filter((role) => role.name === authConstants.ROLE_SUPER_ADMIN).length > 0;
        }

        return false;
    }

    // public logout(): void {
    //     const int = sessionStorage.getItem('int') ?? '';
    //     const languageList = localStorage.getItem('languageList') ?? '';
    //     const countryList = localStorage.getItem('countryList') ?? '';

    //     localStorage.clear();
    //     sessionStorage.clear();
    //     sessionStorage.setItem('int', int);
    //     localStorage.setItem('languageList', languageList);
    //     localStorage.setItem('countryList', countryList);

    //     const defaultCountry: Country = this.getDefaultCountry();
    //     sessionStorage.setItem('currency', defaultCountry?.currencyCode);

    //     const defaultLang: Language = this.getDefaultLang();
    //     sessionStorage.setItem('lang', defaultLang?.code);
    //     sessionStorage.setItem('mooCorrelationId', uuid.v4());
    // }

    // getDefaultCountry(): Country {
    //     const countryList = JSON.parse(localStorage.getItem('countryList') ?? '');
    //     return countryList.find((country: Country) => country?.defaultCountry);
    // }

    // /* Method to get the default language */
    // getDefaultLang(): Language {
    //     const languageList = JSON.parse(localStorage.getItem('languageList') ?? '');
    //     return languageList.find((language: Language) => language?.defaultLanguage);
    // }
}
